import { useMemo, type ReactNode } from "react";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  PhantomWalletAdapter,
  SolflareWalletAdapter,
  CoinbaseWalletAdapter,
  TrustWalletAdapter,
  WalletConnectWalletAdapter,
} from "@solana/wallet-adapter-wallets";
import { SOLANA_RPC_ENDPOINT, SOLANA_NETWORK } from "./constants";

// WalletConnect Project ID - get yours at https://cloud.walletconnect.com/
const WALLETCONNECT_PROJECT_ID = "f22c9d62efcd06349c016df0dc89f009";

type SolanaWalletProviderProps = {
  children: ReactNode;
};

export const SolanaWalletProvider = ({
  children,
}: SolanaWalletProviderProps) => {
  // Map network string to WalletAdapterNetwork enum
  const network = SOLANA_NETWORK === "mainnet-beta" 
    ? WalletAdapterNetwork.Mainnet 
    : WalletAdapterNetwork.Devnet;

  // Configure supported wallets
  // Order here is the default display order (installed wallets will be sorted first in the UI)
  // Note: Wallets supporting Wallet Standard (like Backpack) are auto-detected
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      new CoinbaseWalletAdapter(),
      new TrustWalletAdapter(),
      new WalletConnectWalletAdapter({
        network,
        options: {
          projectId: WALLETCONNECT_PROJECT_ID,
          metadata: {
            name: "Nordex",
            description: "Nordex - Perpetual Futures Trading",
            url: "https://nordex.trade",
            icons: ["https://nordex.trade/nordex-logo.svg"],
          },
        },
      }),
    ],
    [network]
  );

  return (
    <ConnectionProvider endpoint={SOLANA_RPC_ENDPOINT}>
      {/* Enable autoConnect so wallets reattach after refresh and stay logged in */}
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <WalletProvider wallets={wallets} autoConnect={true}>
        {children as any}
      </WalletProvider>
    </ConnectionProvider>
  );
};
